module.exports = __webpack_public_path__ + "sports-48-x-48.d28d5b9fa2b18796aa47.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/sports/webfont/sports-48-x-48.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/sports/webfont/sports-48-x-48.svg
// module chunks = styles